import { Component, OnInit, HostListener } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { TimelineService } from '../shared/services/timeline.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Configuration } from '../../app.constants';
import * as moment from 'moment';
import {Location} from '@angular/common';
import * as io from 'socket.io-client';
import { SocketService } from 'app/shared/services/socket.service';

@Component({
  selector: 'app-mobile-action-center',
  templateUrl: './mobile-action-center.component.html',
  styleUrls: ['./mobile-action-center.component.css']
})
export class MobileActionCenterComponent implements OnInit {
  public actions = [];
  public socket: any;
  public totalActions = 0;
  public isLoading = true;
  public serverApiUrl;
  constructor( public mobileNav: MobileNavService,
    public timelineService: TimelineService,
    public auth: AuthService,
    public _location: Location,
    public config: Configuration,
    private socketService:SocketService
    ) { }

  ngOnInit() {
      this.serverApiUrl = this.config.StaticImageUrl;
    // this.socket = io(this.config.SocketUrl);
    this.getAllActions();
    // this.socket.on(`new-action-center-${this.auth.user.associateId}`, function (data) {
    //     if (this.actions[0].day !== 'Today') {
    //         this.actions.unshift({day: 'Today', actions: []})
    //     }
    //     this.actions[0].actions.unshift(data);
    // }.bind(this));

    // this.socketListner();
  }


  socketListner(){
    this.socketService.newActionObs.subscribe(action=>{
        if (this.actions[0].day !== 'Today') {
            this.actions.unshift({day: 'Today', actions: []})
        }
        this.actions[0].actions.unshift(action);
    });
  }


  onClickMe() {
    this.mobileNav.showSideNav();
  }
    getAllActions() {
        const current = moment();
        const yesterday = moment().add('days', -1);

        this.timelineService.getAllActions(this.auth.user.associateId,'' , '', 0,this.actions.length + 10).subscribe(data1 => {
            this.isLoading = false;
            const datas = Object.assign([], data1['data'])
            this.totalActions = data1['length']
            this.actions = [];
            const obj = {day: '', actions: []};

            datas.filter(data => {
                if (current.format('DD MMM YYYY') === moment(data.date).format('DD MMM YYYY')) {
                    if (obj.day !== 'Today') {
                        if (obj.actions.length) {
                            this.actions.unshift(Object.assign({}, obj))
                        }
                        obj.day = 'Today'
                        obj.actions = [];
                        obj.actions.unshift(data)
                    }else {
                        obj.actions.unshift(data)
                    }
                } else if (yesterday.format('DD MMM YYYY') === moment(data.date).format('DD MMM YYYY')) {
                    if (obj.day !== 'Yesterday') {
                        if (obj.actions.length) {
                            this.actions.unshift(Object.assign({}, obj))
                        }
                        obj.day = 'Yesterday'
                        obj.actions = [];
                        obj.actions.unshift(data)
                    } else {
                        obj.actions.unshift(data)
                    }
                } else if (obj.day !== moment(data.date).format('DD MMM YYYY')) {
                    if (obj.actions.length) {
                        this.actions.unshift(Object.assign({}, obj))
                    }
                    obj.day = moment(data.date).format('DD MMM YYYY')
                    obj.actions = [];
                    obj.actions.unshift(data)
                } else {
                    obj.actions.unshift(data)
                }
            })
            if (obj.day) {
                this.actions.unshift(Object.assign({}, obj))
            } else {
                this.actions = [{day: 'Today', actions: []}];
            }
        },error => {
            this.isLoading = false;
        })
    }

    backBtnClick(){
        this._location.back();
    }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        let h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';
        var percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
        if (percent === 100 && this.actions.length < this.totalActions && !this.isLoading) {
            this.isLoading = true;
          this.getAllActions();
        }
      }
}
